module.exports = __webpack_public_path__ + "19531a1220dd162c0d6b1d545352c289.png";